module.exports = __webpack_public_path__ + "img/paint-slice_05.21aed497.jpg";